(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nogo-collection-product-catalog"] && !Shopify.designMode) return;
  try {
    
  // Delegation also handles sections reloaded in the theme editor.
  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('[data-nogo-catalog] [data-nogo-color]');
    if (!swatch || !swatch.dataset.colorImage) return;
    const card = swatch.closest('.nogo-product-card');
    const image = card && card.querySelector('.nogo-product-card__image');
    if (!image) return;
    // Remove responsive candidates so the browser cannot retain the previous color.
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = swatch.dataset.colorImage;
    image.alt = swatch.dataset.colorAlt || '';
    card.querySelectorAll('[data-nogo-color]').forEach(function (button) {
      button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
